// Plan 06-05 — RoleGuard.
//
// D-140: defesa em profundidade. Server middleware é a fonte da verdade.
// Este componente bloqueia render client-side caso roles não interceptem.

import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useSession } from '../contexts/SessionContext';

export function RoleGuard({
  requires,
  children,
}: {
  requires: ReadonlyArray<string>;
  children: ReactNode;
}): JSX.Element {
  const { t } = useTranslation();
  const { session } = useSession();
  if (!session) {
    return (
      <p role="alert" className="alert alert-error">
        {t('common.not_authenticated')}
      </p>
    );
  }
  const userRoles = session.user.roles ?? [];
  const allowed = requires.some((r) => userRoles.includes(r));
  if (!allowed) {
    return (
      <p role="alert" className="alert alert-error">
        {t('common.forbidden')}
      </p>
    );
  }
  return <>{children}</>;
}
